import { render, staticRenderFns } from "./ListaDisciplinaCompetencia.vue?vue&type=template&id=6d469b2a"
import script from "./ListaDisciplinaCompetencia.vue?vue&type=script&lang=js"
export * from "./ListaDisciplinaCompetencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports